import { render, staticRenderFns } from "./cfdeLanding2.vue?vue&type=template&id=a8459162&scoped=true"
import script from "./cfdeLanding2.vue?vue&type=script&lang=js"
export * from "./cfdeLanding2.vue?vue&type=script&lang=js"
import style0 from "./cfdeLanding2.vue?vue&type=style&index=0&id=a8459162&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8459162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8459162')) {
      api.createRecord('a8459162', component.options)
    } else {
      api.reload('a8459162', component.options)
    }
    module.hot.accept("./cfdeLanding2.vue?vue&type=template&id=a8459162&scoped=true", function () {
      api.rerender('a8459162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeLanding2.vue"
export default component.exports